import React, { useContext } from "react";
import styled from "styled-components";
import BlackLayer from "./BlackLayer";
import List from "../List/List";
import AvatarUser from "../Avatar/AvatarUser";
import Labels from "../Label/Labels";
import { IC, ListIcon } from "../../../resources/Assets";
import { getToday } from "../../../views/Reservation/ResrvList";
import Button from "../Button/Button";
import { AppContext } from "../../AppProvider";

const DoctorInfoLayer = props => {
  const { doctor, item, resrvLayer, dupReceipt, ReceiptNftf } = props;
  const { dispatch } = useContext(AppContext);

  const nHour = getToday("FULL").substring(8, 10);
  const nMin = getToday("FULL").substring(10, 12);

  return (
    <BlackLayer>
      <BottomSheet>
        <Header onClick={props.fn_close}>
          <img src={IC.etc.ICON_X_CIRCLE} />
        </Header>
        <Body>
          <List
            data={{
              STATUS: "default",
              L_ICON: (
                <AvatarUser
                  active={
                    doctor.doctor[0].DrName.split(" ").length == 1
                      ? true
                      : false
                  }
                />
              ),
              TITLE: [
                <div style={{ display: "flex", gap: "4px" }}>
                  {doctor.doctor[0].doctorName}
                  {doctor.doctor[0].DrName.split(" ").length == 1 && (
                    <img src={IC.camera.ICON_CAMERA_GREEN} />
                  )}
                </div>,
              ],
              SUB_TEXT: {
                status: "default",
                text: (
                  <Labels
                    labels={[
                      {
                        status: "default",
                        text: doctor.doctor[0].mdclSubNm,
                      },
                    ]}
                  />
                ),
              },
              R_ICON: "",
              ACTION: "",
              Body: [
                doctor.doctor[0].description && (
                  <ModalBody>
                    {doctor.doctor[0].description
                      .split("\n")
                      .map((text, idx) => (
                        <span key={"text" + idx}>{text}</span>
                      ))}
                  </ModalBody>
                ),
              ],
              ps:
                "해당 페이지에서 접수 시 " +
                doctor.doctor[0].doctorName +
                " 의사에게 접수됩니다",
            }}
          />
        </Body>
        <Bottom>
          <div
            style={{
              width: "100%",
              display: "flex",
              gap: "8px",
              backgroundColor: "#FFF",
              background:
                "linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.7) 79%, #fff 58%)",
            }}>
            {/* {item.hospital[0].myhp != "0" */}
            {doctor.doctor[0].DrName.split(" ").length == 1
              ? [
                  (item.hospital[0].receiptUseType.toString() === "1" ||
                    item.hospital[0].receiptUseType.toString() === "9") &&
                    item.hospital[0].appSTime <= nHour + nMin &&
                    item.hospital[0].appETime >= nHour + nMin && (
                      <Button
                        severity="primary_light"
                        disable="off"
                        clickEvent={() => {
                          if (item.aplnBtnYn === "Y") {
                            resrvLayer(
                              "0",
                              item.hospital[0].hpName,
                              item.hospital[0].hpKey,
                              props.setDoctorList,
                              item.hospital[0].appDr
                            );
                          } else {
                            dupReceipt();
                          }
                        }}>
                        방문진료 접수신청
                      </Button>
                    ),
                  (item.hospital[0].receiptUseType.toString() === "2" ||
                    item.hospital[0].receiptUseType.toString() === "9") &&
                    item.hospital[0].callETime >= nHour + nMin && (
                      <Button
                        severity="primary"
                        disable="off"
                        clickEvent={() => {
                          ReceiptNftf();
                          dispatch({ type: "SET_NFTF_DOCTOR", data: doctor });
                        }}>
                        비대면진료 접수신청
                      </Button>
                    ),
                ]
              : [
                  <Button
                    severity="light"
                    disable="on"
                    clickEvent={() => console.log("테스트")}>
                    접수가능 시간이 아닙니다
                  </Button>,
                ]}
          </div>
        </Bottom>
      </BottomSheet>
    </BlackLayer>
  );
};

const BottomSheet = styled.div`
  width: 100%;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding: 16px 0 0;
  box-shadow: 0 -8px 40px 0 rgba(0, 0, 0, 0.15);
  background-color: #fff;
  position: fixed;
  bottom: 0;
  border-radius: 16px 16px 0px 0px;
`;

const Header = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  padding: 8px 16px;
`;

const Body = styled.div`
  align-self: stretch;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding: 0px 20px;
`;

const Bottom = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  padding: 24px 20px;
`;

const ModalBody = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
  padding: 16px;
  border-radius: 6px;
  background-color: #fff;
  max-height: 160px;
  overflow-y: auto;
`;
export default DoctorInfoLayer;
